// ─────────────────────────────────────────────
// API Configuration
// Switch between local and hosted by changing REACT_APP_BASE_URL in .env
// ─────────────────────────────────────────────

export const BASE_URL = process.env.REACT_APP_BASE_URL || "https://cost-control-project.onrender.com/api/v1";
